<template>
  <header class="flex justify-between items-center py-4">
    <div class="flex gap-10 items-center">
      <router-link to="/">
        <figure class="title__box flex text-4xl sm:text-5xl font-semibold">
          <p class="title__adbox">
            Ad
          </p>
          box
        </figure>
      </router-link>
      <nav class="hidden xl:block">
        <ul class="grid grid-flow-col gap-6 cursor-pointer">
          <router-link to="/discover" class="flex items-center whitespace-no-wrap hover:bg-gray-200 duration-500">
            <li class="flex relative">
              <span class="p-2">Discover</span>
            </li>

          </router-link>
          <li @mouseover="
            status ? (openMenuLearn = true) : (openMenuLearn = false)
            " @mouseleave="openMenuLearn = false" class="flex relative">
            <span class="p-2">Resources</span>
            <transition name="fade">
              <ul class="grid grid-flow-col absolute rounded-md mt-8 pb-2 z-50 bg-white shadow-md" v-if="openMenuLearn"
                @click="openMenuLearn = false">
                <div>
                  <router-link to="/top-brands"
                    class="flex items-center whitespace-no-wrap hover:bg-gray-200 duration-500">
                    <li class="p-3 text-sm pr-10">
                      <span>{{ top_brand_title_subtitle.title }}</span>
                    </li>
                  </router-link>

                  <router-link to="/ugc-creators" class="flex items-center hover:bg-gray-200 duration-500">
                    <li class="p-3 text-sm pr-10 whitespace-no-wrap">
                      <span> {{ ugc_creator_title_subtitle.title }} </span>
                    </li>
                  </router-link>
                  <router-link to="/hooks" class="flex items-center whitespace-no-wrap hover:bg-gray-200 duration-500">
                    <li class="p-3 text-sm pr-10">
                      <span>{{ hooks_title_subtitle.title }}</span>
                    </li>
                  </router-link>
                  <router-link to="/calendar" class="flex items-center whitespace-no-wrap hover:bg-gray-200 duration-500">
                    <li class="p-3 text-sm pr-10 hover:bg-gray-200 duration-500">
                      <span>{{ calendar_title_subtitle.title }}</span>
                    </li>
                  </router-link>
                </div>
                <div>
                  <router-link to="/ads-test-first"
                    class="flex items-center whitespace-no-wrap hover:bg-gray-200 duration-500">
                    <li class="p-3 text-sm pr-10">
                      <span>{{ ads_test_first_title_subtitle.title }}</span>
                    </li>
                  </router-link>
                  <router-link to="/psychology" class="flex items-center hover:bg-gray-200 duration-500">
                    <li class="p-3 text-sm pr-10 whitespace-no-wrap">
                      <span>{{ psycology_title_subtitle.title }}</span>
                    </li>
                  </router-link>

                  <router-link to="/case-studies" class="flex items-center hover:bg-gray-200 duration-500">
                    <li class="p-3 text-sm pr-10 whitespace-no-wrap">
                      <span>{{ case_study_title_subtitle.title }}</span>
                    </li>
                  </router-link>
                  <router-link to="/deals-and-tools" class="flex items-center hover:bg-gray-200 duration-500">
                    <li class="p-3 text-sm pr-10 whitespace-no-wrap">
                      <span>{{ deals_tools_title_subtitle.title }}</span>
                    </li>
                  </router-link>
                </div>
              </ul>
            </transition>
          </li>
          <router-link to="/favorites" class="flex items-center whitespace-no-wrap hover:bg-gray-200 duration-500">
            <li class="flex relative">
              <span class="p-2">My Favorites</span>
            </li>

          </router-link>
          <li v-if="((role == 'free' ||
            role == 'monthly' ||
            role == 'annual' ||
            role == 'lifetime') &&
            !status) ||
            role == 'monthly'
            " class="flex relative">
            <router-link to="/pricing" class="flex items-center">
              <span class="p-2">Pricing</span>
            </router-link>
          </li>
          <!--   <li v-if="status" class="flex relative ">
            <a
              href="https://adbox.getrewardful.com/signup"
              target="_blank"
              class=" flex items-center p-0 m-0"
            >
              <span class="pb-0 mb-0"> Become an Affiliate </span>
            </a>
          </li>
          <li v-else class="flex relative no-click ">
            <a
              href="https://adbox.getrewardful.com/signup"
              target="_blank"
              class=" flex items-center p-0 m-0"
            >
              <span class="pb-0 mb-0"> Become an Affiliate </span>
            </a>
          </li>
          -->
          <!-- <li class="flex">
            <router-link to="/deals-and-tools" class="flex items-center">
              <span class="p-2">Deals & Tools</span>
            </router-link>
          </li> -->
        </ul>
      </nav>
    </div>
    <div class="flex gap-5 items-center">
      <div class="hidden xl:block" v-if="user">
        <div @click="activesubMenu('User')" class="flex items-center relative cursor-pointer">
          <img :src="user.picture" alt="" class="w-12 mr-3" />
        </div>
        <transition name="fade">
          <ul class="grid grid-flow-row absolute rounded-md mt-3 z-10 bg-white shadow-md" v-if="openMenuUser"
            @click="openMenuUser = false">
            <li class="p-3 text-sm pr-10 font-medium">
              <router-link to="/account" class="flex items-center">
                <span> Account settings</span>
              </router-link>
            </li>
            <li class="p-3 text-sm pr-10">
              <a href="https://adbox2.canny.io/feature-requests-and-bug-reports" target="_blank"
                class="flex items-center"><span>Knowledge Requests</span>
              </a>
            </li>
            <li class="p-3 text-sm pr-10">
              <router-link to="/account/subscription" class="flex items-center">
                <span>Billing</span>
              </router-link>
            </li>
            <li class="p-3 text-sm pr-10">
              <router-link to="/account/support" class="flex items-center">
                <span>Support</span>
              </router-link>
            </li>
            <li class="p-3 text-sm pr-5">
              <a href="https://adbox.getrewardful.com/signup" target="_blank" class="flex items-center"><span>Become an
                  Affiliate</span>
              </a>
            </li>
            <!-- <li class="p-3 text-sm pr-10">
              <router-link to="/favorites" class="flex items-center">
                <span>Feature Request</span>
              </router-link>
            </li> -->
            <li @click="signoutVisible = true" class="p-3 text-sm pr-10">
              <div class="flex items-center">
                <span>Sign Out</span>
              </div>
            </li>
          </ul>
        </transition>
      </div>
    </div>
    <SignOutModal v-model:isVisible="signoutVisible" />
  </header>
</template>

<script>
// import Icon from "@/components/UI/Icon";
import { useStore } from "vuex";
import { computed, ref } from "vue";
import SignOutModal from "@/components/Modals/SignOut";
// import Icon from "@/components/UI/Icon";
export default {
  components: { SignOutModal },

  setup() {
    const openMenuDiscover = ref(false);
    const openMenuLearn = ref(false);
    const openMenuUser = ref(false);
    const signoutVisible = ref(false);

    const activesubMenu = (value) => {
      if (value === "Discover") {
        openMenuLearn.value = false;
        openMenuUser.value = false;
        openMenuDiscover.value = !openMenuDiscover.value;
      } else if (value === "Learn") {
        openMenuDiscover.value = false;
        openMenuUser.value = false;
        openMenuLearn.value = !openMenuLearn.value;
      } else {
        openMenuDiscover.value = false;
        openMenuLearn.value = false;
        openMenuUser.value = !openMenuUser.value;
      }
    };
    const store = useStore();

    const status = computed(() => store.state.status);
    const user = computed(() => store.state.user);
    const role = computed(() => store.state.role);
    const fb_ig_title_subtitle = computed(() => store.state.fbIgTitleSubtitle);
    const discover_subtitle = computed(() => store.state.discoverSubtitle);
    const tiktok_title_subtitle = computed(
      () => store.state.tiktokTitleSubtitle
    );
    const home_title_subtitle = computed(() => store.state.homeTitleSubtitle);
    const hooks_title_subtitle = computed(() => store.state.hooksTitleSubtitle);
    const top_brand_title_subtitle = computed(
      () => store.state.topBrandTitleSubtitle
    );
    const calendar_title_subtitle = computed(
      () => store.state.calendarTitleSubtitle
    );
    const ads_test_first_title_subtitle = computed(
      () => store.state.adsToTestFirstTitleSubtitle
    );
    const psycology_title_subtitle = computed(
      () => store.state.psycologyTitleSubtitle
    );
    const case_study_title_subtitle = computed(
      () => store.state.caseStudiesTitleSubtitle
    );
    const deals_tools_title_subtitle = computed(
      () => store.state.dealsToolsTitleSubtitle
    );
    const ugc_creator_title_subtitle = computed(
      () => store.state.ugcCreatorsTitleSubtitle
    );

    return {
      status,
      user,
      role,
      fb_ig_title_subtitle,
      discover_subtitle,
      home_title_subtitle,
      tiktok_title_subtitle,
      top_brand_title_subtitle,
      hooks_title_subtitle,
      calendar_title_subtitle,
      ads_test_first_title_subtitle,
      psycology_title_subtitle,
      case_study_title_subtitle,
      deals_tools_title_subtitle,
      ugc_creator_title_subtitle,
      openMenuDiscover,
      openMenuLearn,
      openMenuUser,
      activesubMenu,
      signoutVisible,
    };
  },
};
</script>

<style>
.no-click {
  pointer-events: none;
}

.title__box {
  letter-spacing: -2px;
  color: #333;
}

.title__adbox {
  color: #3652d9;
}

.router-link-exact-active {
  font-weight: 600;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>
